'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'table';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f0ce';
var svgPathData = 'M384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64l-320 0-6.5-.3C25.2 476.4 0 449.1 0 416L0 96C0 60.7 28.7 32 64 32l320 0zM48 312l0 104c0 8.8 7.2 16 16 16l136 0 0-120-152 0zm200 0l0 120 136 0c8.8 0 16-7.2 16-16l0-104-152 0zM48 264l152 0 0-104-152 0 0 104zm200 0l152 0 0-104-152 0 0 104z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTable = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;